import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_all_announcements_admin, duplicate_announcement } from '../../api/announcementAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_time_difference } from '../../utils/helper';
import notify from '../../utils/IANotification';
import DataTable from '../../components/ui/DataTable'

export default function AnnouncementPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [announcements, setAnnouncements] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetch_announcements()
  }, [])

  const fetch_announcements = async () => {
    setLoading(true)
    const data = await fetch_all_announcements_admin()
    if (data?.status === 200) {
      setAnnouncements(data.data?.reverse())
    }
    setLoading(false)
  }


  const handle_duplicate_announcement = async (announcement_id) => {
    const data = await duplicate_announcement({ announcement_id })
    if (data.status === 200) {
      fetch_announcements()
      notify({ message: data.message, type: "success" })
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const numberCommas = (x) => {
    if (!x && x !== 0) return ""
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const table_columns = [
    {
      header: "",
      accessor: "file_data.ext_file_path",
      modifier: (data, row) => <img src={data ? `${config.endpoint}${data}` : "/default/default.jpg"} alt="announcement" style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }} />
    },
    {
      header: "Title",
      accessor: "title"
    },
    {
      header: "Date & Time",
      accessor: "start_datetime",
      modifier: (data, row) => `${tidy_date(row?.start_datetime)} - ${row?.is_forever == 1 ? "No End Date" : tidy_date(row?.end_datetime)}`
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data, row) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
    ,
    {
      header: "Views",
      accessor: "view_count",
      modifier: (data, row) => numberCommas(data) || 0
    }
  ]

  return (
    <AdminLayout
      navSelected={"Announcements"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Announcements</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/announcements/details?announcement_id=new")
            }}
          >
            <MdAdd size={16} />
            New Announcement
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}


      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={announcements}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button
                    className="backgroundLess"
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      handle_duplicate_announcement(row.id)
                    }}
                  >
                    Duplicate
                  </button>
                  <button
                    className="hover:underline"
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      navigate("/admin/announcements/details?announcement_id=" + row.id)
                    }}
                  >
                    View
                  </button>
                </div>
              )
            }}
          />
          {/* {announcements.map((announcement, index) => {
            if (!JSON.stringify(announcement).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10" style={{ padding: 0 }}
              >
                <img src={announcement.file_data?.ext_file_path ? `${config.endpoint}${announcement.file_data?.ext_file_path}` : "/default/default.jpg"} alt="announcement" className="card-image" style={{ width: 100, height: 100, objectFit:"cover" }} />
                <div className="flex-row flex gap-2 items-center p-all w-100 justify-between">
                  <div className="">

                    <h3>{announcement.title}</h3>
                    <h3 className='card-subtitle'>{announcement?.is_forever == 1 ? "No end date" : `${tidy_date(announcement.start_datetime)} - ${tidy_date(announcement.end_datetime)}`}</h3>
                  </div>
                  <div className="flex-row flex gap-2 items-center">
                    <button
                      className="backgroundLess"
                      style={{ fontSize: 12 }}
                      onClick={() => {
                        handle_duplicate_announcement(announcement.id)
                      }}
                    >
                      Duplicate
                    </button>
                    <button
                      className="backgroundLess"
                      style={{ fontSize: 12 }}
                      onClick={() => {
                        navigate("/admin/announcements/details?announcement_id=" + announcement.id)
                      }}
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            )
          })} */}
        </div>
      )}
    </AdminLayout>
  )
}
